import { TestComponent1, TestComponent2 } from "@react/ReactTest";
import angular from "angular";
import CCQAuthWrapper from "./react/components/CCQAuthWrapper";
import LoginCallback from "./react/components/LoginCallback";
import { react2angular } from "react18-react2angular";

export function registerReactComponents() {
  const module = angular.module('ccqapp');

  module.factory('baseUrl', ['$location', function($location) {
    return $location.protocol() + '://' + $location.host() +
      ($location.port() ? ':' + $location.port() : '');
  }]);

  module
      .component(
          "ccqAuthWrapper",
          react2angular(CCQAuthWrapper, [], ["$rootScope"]),
  )
      .component(
          "loginCallback",
          react2angular(LoginCallback, [], ["$rootScope"]),
      )
    .component("testComponent1", react2angular(TestComponent1))
    .component(
      "testComponent2",
      react2angular(TestComponent2, ["fooBar", "baz"]),
    );
}
